import styled from 'styled-components';
import { Favorite16 } from 'ui/icons/aurora/16px/Favorite16';
import { FavoriteFilled16 } from 'ui/icons/aurora/16px/FavoriteFilled16';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { TipPlacement } from 'ui/tooltip/types';

type FavoriteProps = {
  isVisible: boolean;
  isSelected: boolean;
  onClick: () => void;
};

const StyledButton = styled.button`
  display: flex;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
`;

export const Favorite = ({ isVisible, isSelected, onClick }: FavoriteProps) => {
  if (!isVisible) return null;

  return (
    <Tooltip
      tooltipContent={isSelected ? 'Remove from favorites' : 'Add to favorites'}
      placement={TipPlacement.Top}
    >
      <StyledButton onClick={onClick}>
        {isSelected ? (
          <FavoriteFilled16 data-test="favorite-selected" />
        ) : (
          <Favorite16 data-test="favorite-unselected" />
        )}
      </StyledButton>
    </Tooltip>
  );
};
